import envData from './env'

let customerId

export const setAPIUserInfo = userInfo => {
  ({ customerId } = userInfo)
}

const getPaymentsAPI = (version = 1) => `${envData.apiUrl}/payments-service/v${version}`
const getConferenceAPI = (version = 1) => `${envData.vmmsUrl}/virtualmeeting/v${version}`

const URLS = {
  get customerConferenceSettings () {
    return `${getConferenceAPI(2)}/customers/${customerId}/conference-settings`
  },

  get ANDROID_CALLBACK_URL () {
    return envData.androidCallbackUrl
  },

  get JAAS () {
    return envData.jaasUrl
  },

  get PRODUCTS () {
    return `${getPaymentsAPI()}/products`
  },
  COUPON (key) {
    return `${getPaymentsAPI()}/products/coupon?couponKey=${key}`
  },
  CREATE_SUBSCRIPTION (params) {
    const searchParams = new URLSearchParams(params)
    return `${getPaymentsAPI()}/customers/${customerId}/subscriptions?${searchParams}`
  },
  get CREATE_FREE_SUBSCRIPTION () {
    return `${getPaymentsAPI(2)}/customers/${customerId}/subscriptions`
  },
  get SUBSCRIPTIONS () {
    const searchParams = new URLSearchParams({
      statusType: 'VALID'
    })
    return `${getPaymentsAPI(2)}/customers/${customerId}/subscriptions?${searchParams}`
  },
  get CARD_CONTROLLER () {
    return `${getPaymentsAPI()}/customers/${customerId}/payment-methods`
  },
  get DEFAULT_PAYMENT_METHOD () {
    return `${getPaymentsAPI()}/customers/${customerId}/payment-methods/default`
  },
  get INVOICES () {
    return `${getPaymentsAPI()}/customers/${customerId}/invoices`
  },
  get DELETE_SUBSCRIPTION () {
    return `${getPaymentsAPI()}/customers/${customerId}/subscriptions`
  },

  TEAM: {
    get MEMBERS () {
      return `${getConferenceAPI()}/standalone/team/members`
    }
  }
}

export default URLS
